export default __webpack_public_path__ + "static/media/20.be8fe2cf.jpg";